module.exports = __webpack_public_path__ + "static/media/feedback_survey_response.acb79a5c.png";